<template>
    <!-- <v-row justify="center"> -->
        <v-dialog persistent v-model="isShow" :content-class="contentClass">
            <v-card>
                <v-card-title class="d-block card-title text-center pb-6" style>{{title}}</v-card-title>
                <v-card-text class="text-center card-text" v-show="!$slots.default" v-html="content"></v-card-text>
                <slot v-if="$slots.default"></slot>
                <v-card-actions class="card-actions d-felx pa-0">
                    <div
                        v-ripple
                        class="cancel-div text-center"
                        v-if="showCancelText"
                        @click="cancelFun"
                    >{{cancelText}}</div>
                    <div class="splice-border" v-if="showCancelText"></div>
                    <div
                        v-ripple
                        class="confirm-div text-center"
                        @click="confirmFun"
                    >{{confirmText}}</div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    <!-- </v-row> -->
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: "提示"
        },
        contentClass:{
            type: String,
            default: ""
        },
        confirmText: {
            type: String,
            default: "确定"
        },
        cancelText: {
            type: String,
            default: "取消"
        },
        showCancelText: {
            type: Boolean,
            default: true
        },
        content: {
            type: String
        },
        isShow: {
            type: Boolean,
            default: false
        },
        onConfirm: {
            type: Function,
            default: () => {}
        },
        onCancel: {
            type: Function,
            default: () => {}
        },
    },
    watch: {
        // isShow() {
        //     this.showDialog = this.isShow;
        // },
        // showDialog() {
        //     // this.$emit("update:isShow", this.showDialog);
        // }
    },
    methods: {
        confirmFun() {
            this.$emit("update:isShow", false);
            this.showDialog = false;
            this.onConfirm();
        },
        cancelFun() {
            this.$emit("update:isShow", false);
            this.showDialog = false;
            this.onCancel();
        }
    }
};
</script>

<style lang="scss" scoped>
.v-card {
    .card-title {
        font-size: 16px;
        line-height: 1.5;
    }
    .card-text {
        color: #333;
        font-size: 14px;
        line-height: 1.5;
        padding: 0 20px 20px;
    }
    .card-actions {
        border-top: 1px solid #eee;
        position: relative;
        padding: 0;

        .splice-border {
            position: absolute;
            left: 50%;
            top: 0;
            height: 100%;
            transform: translateX(-50%);
            width: 1px;
            background: #eee;
            content: "";
        }
        .cancel-div {
            color: #999999;
        }
        .confirm-div {
            color: rgb(53, 127, 224);
        }
        .cancel-div,
        .confirm-div {
            flex: 1;
            font-size: 14px;
            height: 44px;
            line-height: 44px;
        }
        // .cancel-div{color: #666666;}
    }
}
</style>